export const iconFontAwesomeAlphabetV = (
	<i className="fa-solid fa-v"></i>
);
